import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Circle, Hexagon } from "lucide-react";

interface SportSelectorProps {
  selectedSport: string;
  onSportChange: (sport: string) => void;
}

const SportSelector = ({ 
  selectedSport, 
  onSportChange 
}: SportSelectorProps) => {
  const sports = [
    { 
      id: 'Pádel', 
      name: 'Pádel', 
      icon: (
        <div className="w-full h-full flex items-center justify-center relative">
          <img src="/lovable-uploads/5b084fa7-1691-4ba9-84d3-9c2aaabd012a.png" alt="Pádel" className="w-8 h-8 object-contain" />
        </div>
      )
    },
    { 
      id: 'Tenis', 
      name: 'Tenis', 
      icon: (
        <div className="w-full h-full flex items-center justify-center relative">
          <span className="text-2xl">🎾</span>
        </div>
      )
    },
    { 
      id: 'Pickleball', 
      name: 'Pickleball', 
      icon: (
        <div className="w-full h-full flex items-center justify-center relative">
          <img src="/lovable-uploads/1bcd1940-66b0-4c8c-aa95-3f6e609dd00b.png" alt="Pickleball" className="w-8 h-8 object-contain" />
        </div>
      )
    }
  ];

  const currentSport = sports.find(sport => sport.id === selectedSport) || sports[0];

  return (
    <div className="flex flex-col items-center">
      {/* Sport Selector - Circular */}
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button 
            variant="outline" 
            className="w-14 h-14 md:w-20 md:h-20 rounded-xl bg-white border-2 border-primary shadow-lg hover:shadow-xl transition-all duration-200 p-0 hover:bg-gray-50 hover:border-primary/70"
          >
            {currentSport.icon}
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="center" className="w-48 bg-white border shadow-lg">
          {sports.map((sport) => (
            <DropdownMenuItem
              key={sport.id}
              onClick={() => onSportChange(sport.id)}
              className="flex items-center gap-3 p-3 cursor-pointer hover:bg-gray-50"
            >
              <div className="w-8 h-8 rounded-full bg-gray-100 flex items-center justify-center">
                {sport.icon}
              </div>
              <span className="font-medium">{sport.name}</span>
            </DropdownMenuItem>
          ))}
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
};

export default SportSelector;